<table class="table table-responsive-sm table-sm table-bordered table-striped">
  <thead class="table">
    <tr>
      <td *ngFor="let col of columns" [ngStyle]="{'width': col.cellWidth, 'text-align': col.textAlign}">
        <div *ngIf="col.disableSorting==false">
          <b>
            <a class="pointer" (click)="sortData(col.name)">{{col.description}}</a>
          </b>

          <span *ngIf="col.name == sortColumn && sortAscending == true">
            <i class="fa fa-caret-down"></i>
          </span>
          <span *ngIf="col.name == sortColumn && sortDesending == true">
            <i class="fa fa-caret-up"></i>
          </span>
        </div>

        <div *ngIf="col.disableSorting==true">
          <b>{{col.description}}</b>
        </div>
      </td>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let row of rows; let i = index" class="rowDatagrid">
      <td *ngFor="let col of columns" [ngStyle]="{'width': col.width, 'text-align': col.textAlign}">

        <div *ngIf="col.hyperLink == false && col.singleButton == false && col.multiButton == false">
          <span class="table-responsive-custom">
            <b>{{col.description}}:&nbsp;</b>
          </span>

          <div *ngIf="col.formatDate == true && col.formatDateTime == false">{{row[col.name] | date:"dd-MM-yyyy"}}</div>
          <div *ngIf="col.formatDateTime == true && col.formatDate == false">
            {{row[col.name] | date:"dd-MM-yyyy HH:mm:ss" }}</div>
          <div
            *ngIf="col.formatDate == false && col.formatDateTime == false && col.formatNumber == true && col.formatMoney == false">
            {{row[col.name] | number }}</div>
          <div
            *ngIf="col.formatDate == false && col.formatDateTime == false && col.formatNumber == false && col.formatMoney == true">
            {{row[col.name] | currency: 'EUR'}}</div>
          <div
            *ngIf="col.formatDate == false && col.formatDateTime == false && col.formatNumber == false && col.formatMoney == false">
            {{row[col.name]}}</div>
        </div>

        <div *ngIf="col.hyperLink == true">
          <span class="table-responsive-custom" style="width:100%">
            <b>{{col.description}}:&nbsp;</b>
          </span>
          <div style="cursor:pointer;" (click)="selectedRow(i)">
            <div *ngIf="col.formatDate == true && col.formatDateTime == false">{{row[col.name] | date:"dd-MM-yyyy"}}
            </div>
            <div *ngIf="col.formatDateTime == true && col.formatDate == false">
              {{row[col.name] | date:"dd-MM-yyyy HH:mm:ss" }}</div>
            <div *ngIf="col.formatDate == false && col.formatDateTime == false">{{row[col.name]}}</div>
          </div>
        </div>

        <div *ngIf="col.singleButton == true">
          <span class="table-responsive-custom" style="width:100%">
            <b>{{col.description}}:&nbsp;</b>
          </span>
          <button *ngIf="col.buttonEdit" type="button" class="btn btn-sm btn-success py-0"
            (click)="buttonClicked(col.buttonText,i)">
            <i class="fa fa-edit fa-2xs"></i>
          </button>
          <button *ngIf="col.buttonDelete" type="button" class="btn btn-sm btn-danger py-0" [ladda]='laddaButton(i)'
            (click)="buttonClicked(col.buttonText,i)">
            <b>{{col.buttonText}}</b>
          </button>
          <button *ngIf="col.buttonUpload && allowUpload()" type="button" class="btn btn-sm btn-dark py-0"
            [ladda]="workingButtonState(col.buttonText,row)" data-style="zoom-out"
            (click)="buttonClicked(col.buttonText,i)">
            <i class="fa fa-upload fa-2xs"></i>
          </button>
          <button *ngIf="col.buttonDownloadPdf && allowDownload(i)" type="button" class="btn btn-sm btn-primary py-0"
            [ladda]="workingButtonState(col.buttonText,row)" data-style="zoom-out"
            (click)="buttonClicked(col.buttonText,i)">
            <i class="fa fa-download fa-2xs"></i>
          </button>
          <button *ngIf="col.buttonDownloadExcel && allowDownload(i) && allowExtracto(i)" type="button" class="btn btn-sm btn-success py-0"
            [ladda]="workingButtonState(col.buttonText,row)" data-style="zoom-out"
            (click)="buttonClicked(col.buttonText,i)">
            <i class="fa fa-file-excel-o fa-2xs"></i>
          </button>
          <button *ngIf="col.buttonAcompanhamento && allowAcompanhamento(i)" type="button" class="btn btn-sm btn-dark py-0"
            [ladda]="workingButtonState(col.buttonText,row)" data-style="zoom-out"
            (click)="buttonClicked(col.buttonText,i)">
            <i class="fa fa-list fa-2xs"></i>
          </button>
          <button *ngIf="col.buttonRegistoKms" type="button" class="btn btn-sm btn-secondary py-0"
            data-toggle="tooltip" data-placement="left" title="Atualização de Kms da viatura"
            [ladda]="workingButtonState(col.buttonText,row)" data-style="zoom-out"
            (click)="buttonClicked(col.buttonText,i)">
            <i class="fa fa-line-chart fa-2xs"></i>
          </button>
        </div>

        <div *ngIf="col.multiButton == true">
          <span class="table-responsive-custom" style="width:100%">
            <b>{{col.description}}:&nbsp;</b>
          </span>
          <div *ngFor="let button of col.buttons" style="float:left">
            <button type="button" class="btn btn-primary" (click)="buttonClicked(button.ButtonText,i)">
              <b>{{button.ButtonText}}&nbsp;</b>
            </button>&nbsp;
          </div>
        </div>

      </td>
    </tr>
  </tbody>
</table>

<div style="float:left">
  <button type="button" class="btn ui-grid-pager-control" (click)="buttonFirstPage()"
    [disabled]="disableFirstPageButton || (totalPages == 1 && this.currentPageNumber == 1)">
    <div class="first-triangle">
      <div class="first-bar"></div>
    </div>
  </button>
  <button type="button" class="btn ui-grid-pager-control" (click)="buttonPreviousPage()"
    [disabled]="disablePreviousPageButton || (totalPages == 1 && this.currentPageNumber == 1)">
    <div class="first-triangle prev-triangle">
    </div>
  </button> &nbsp;{{currentPageNumber}}&nbsp;/&nbsp;{{totalPages}}&nbsp;
  <button type="button" class="btn ui-grid-pager-control" (click)="buttonNextPage()"
    [disabled]="disableNextPageButton || (totalPages == 1 && this.currentPageNumber == 1)">
    <div class="last-triangle">
    </div>
  </button>
  <button type="button" class="btn ui-grid-pager-control" (click)="buttonLastPage()"
    [disabled]="disableLastPageButton || (totalPages == 1 && this.currentPageNumber == 1)">
    <div class="last-triangle">
      <div class="last-bar"></div>
    </div>
  </button>
  <select class="ui-grid-pager-row-count-picker" [(ngModel)]="pageSize" (change)="pageSizeChanged($event.target.value)">
    <option *ngFor="let pageSizeDefault of pageSizes" value="{{pageSizeDefault}}">{{pageSizeDefault}}</option>
  </select> &nbsp;registos por página
</div>

<div class="grid-pager-responsive-custom">
  &nbsp;{{itemNumberBegin}}&nbsp;-&nbsp;{{itemNumberEnd}}&nbsp;de&nbsp;{{totalRows}}&nbsp;registos&nbsp;
</div>
